document.addEventListener("DOMContentLoaded", function () {
  // --------- Block Area (Type 1) ---------
  // const blocks = document.querySelectorAll(".block__area-wrapper--right");
  // const allLinks = document.querySelectorAll("[data-menu-title]");
  // if (![...blocks].some(b => b.classList.contains("active")) && blocks[0]) blocks[0].classList.add("active");
  // allLinks.forEach(link => {
  //   link.addEventListener("mouseover", () => {
  //     const title = link.dataset.menuTitle;
  //     blocks.forEach(b => b.classList.toggle("active", b.dataset.menuMatch === title));
  //     // allLinks.forEach(l => l.classList.remove("active"));
  //     link.classList.add("active");
  //   });
  // });

document.querySelectorAll('.block__mega-menu-child-li[data-menu-title]').forEach(item => {
  item.addEventListener('mouseenter', () => {
    const menuTitle = item.getAttribute('data-menu-title');
    const megaMenu = item.closest('.mega-menu');
    if (!megaMenu) return;
    const blocks = megaMenu.querySelectorAll('.block__area-wrapper--right');
    blocks.forEach(block => {
      const match = block.getAttribute('data-menu-match');
      if (match === menuTitle) {
        block.classList.add('active');
      } else {
        block.classList.remove('active');
      }
    });    
    megaMenu.querySelectorAll('.block__mega-menu-child-li').forEach(li => {
      li.classList.toggle('active', li === item);
    });
  });
});
  
  // --------- Left Menu + Right Submenu ---------
  const leftItems = document.querySelectorAll('[data-submenu-match]');
  const rightSubs = document.querySelectorAll('[data-menu-subtitleshow]');
  const rightTitles = document.querySelectorAll('.block_only-match-lishow');

  const showSubmenu = title => {
    rightSubs.forEach(s => s.classList.toggle('active', s.dataset.menuSubtitleshow === title));
    rightTitles.forEach(t => t.style.display = t.dataset.menuSubtitleshow === title ? 'block' : 'none');
  };

  if (leftItems[0]) {
    leftItems[0].classList.add('active');
    showSubmenu(leftItems[0].dataset.submenuMatch);
  }

  leftItems.forEach(item => item.addEventListener('mouseenter', () => {
    leftItems.forEach(i => i.classList.remove('active'));
    item.classList.add('active');
    showSubmenu(item.dataset.submenuMatch);
  }));

  // --------- Mobile: View All Button ---------
  // document.querySelectorAll('.block__type-1--view-all').forEach(viewAll => {
  //   viewAll.addEventListener('click', e => {
  //     e.stopPropagation();
  //     const c = viewAll.closest('.block__mobile_type_1');
  //     const inner = c.querySelector('.block__mobile-submenu-custom-inner');
  //     inner.style.maxHeight = '100%';
  //     viewAll.style.display = 'none';
  //     const closeOnClick = e2 => {
  //       if (!c.contains(e2.target)) {
  //         inner.style.maxHeight = '470px';
  //         viewAll.style.display = 'block';
  //         document.removeEventListener('click', closeOnClick);
  //       }
  //     };
  //     setTimeout(() => document.addEventListener('click', closeOnClick), 10);
  //   });
  // });

// mobile js start
  // --------- Block Menu Type 2 ---------
const type2Items = document.querySelectorAll('.block__link--menutype-2-li-inner');

type2Items.forEach(inner => {
  inner.addEventListener('click', e => {
    const li = inner.closest('li');
    const submenu = li?.nextElementSibling;

    if (!submenu || !submenu.classList.contains('block__childlink--menutype-2-ul')) {
      return;
    }

    e.preventDefault();

    const isActive = li.classList.contains('active');

    document
      .querySelectorAll('.block__childlink--menutype-2-ul')
      .forEach(ul => (ul.style.display = 'none'));

    document
      .querySelectorAll('.block_image-header__menu-inner-submemu')
      .forEach(li => li.classList.remove('active'));

    if (!isActive) {
      submenu.style.display = 'block';
      li.classList.add('active');
    }
  });
});



  // --------- Mobile Color Accordion ---------
  const details = document.querySelectorAll("details[date_mobile-color-match]");
  const showColorSection = match => {
    document.querySelectorAll(".block__mobile-shopcolor-section").forEach(s => {
      s.style.display = s.getAttribute("mobile_shop_color") === match ? "block" : "none";
    });
  };
  details.forEach(d => {
    const s = d.querySelector("summary");
    s.addEventListener("click", e => {
      e.preventDefault();
      const match = d.getAttribute("date_mobile-color-match");
      details.forEach(o => o !== d && o.removeAttribute("open"));
      if (d.hasAttribute("open")) {
        d.removeAttribute("open");
        showColorSection("none");
      } else {
        d.setAttribute("open", true);
        showColorSection(match);
      }
    });
  });
  showColorSection("none");
});